var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-sidesheet",
    { attrs: { active: _vm.localActive }, on: { close: _vm.close } },
    [
      _c("div", { staticClass: "modal-frame" }, [
        _c(
          "div",
          { staticClass: "modal-wrapper" },
          [
            _c(
              "shadow-scroll-container",
              {
                ref: "track",
                staticClass: "modal-track",
                attrs: { "with-top-scroller": true },
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-padding" },
                  [
                    !_vm.hideHeader
                      ? _c("div", { staticClass: "modal-frame__header" }, [
                          _c(
                            "h2",
                            { staticClass: "modal-frame__title" },
                            [
                              _vm._t("title", function () {
                                return [_vm._v(" " + _vm._s(_vm.title) + " ")]
                              }),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "modal-frame__actions" },
                            [_vm._t("header-actions")],
                            2
                          ),
                        ])
                      : _vm._e(),
                    _vm._t("default"),
                  ],
                  2
                ),
              ]
            ),
          ],
          1
        ),
        !_vm.hideFooter
          ? _c("div", { staticClass: "modal-actions" }, [_vm._t("actions")], 2)
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }